/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_Physics16Inputs */

const en__field__enum_teachingsubjectinterest_subject_physics16 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Physics16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physics`)
};

const de__field__enum_teachingsubjectinterest_subject_physics16 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Physics16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physik`)
};

/**
* | output |
* | --- |
* | "Physics" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_Physics16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_physics16 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_Physics16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_Physics16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_physics16(inputs)
	return de__field__enum_teachingsubjectinterest_subject_physics16(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_physics16 as "_field__enum_teachingSubjectInterest_SUBJECT_PHYSICS" }